import { Amplify } from "aws-amplify";

/**
 * Configure Amplify Auth against the CONTRACTOR Cognito User Pool — a
 * separate pool from the customer system, never federated
 * (copilot-instructions System Boundaries rule 6).
 *
 * Same Amplify-over-oidc-client-ts rationale as the customer PWA: the app
 * client uses USER_SRP / `InitiateAuth` (not Hosted UI / OIDC redirect),
 * which Amplify Auth v6 wraps natively — sign-up, email confirmation,
 * sign-in, refresh, and session restore for free.
 *
 * All values come from Vite env vars injected by CI; see env.d.ts and the
 * contractor-dev / contractor-prod workflows. Throwing here surfaces a
 * missing config at app start instead of mid-flow during a sign-in attempt.
 */
function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(
      `Missing required Vite env var ${String(name)}. ` +
        "It must be injected at build time from the CDK Identity stack outputs.",
    );
  }
  return value;
}

export function configureAuth(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: required("VITE_USER_POOL_ID"),
        userPoolClientId: required("VITE_USER_POOL_CLIENT_ID"),
        loginWith: { email: true },
        signUpVerificationMethod: "code",
      },
    },
  });
}
